interface LoadingProps {
  label?: string;
  fullScreen?: boolean;
}

export default function Loading({ label = 'Cargando...', fullScreen = false }: LoadingProps) {
  const content = (
    <div className="flex flex-col items-center justify-center gap-3 py-10 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100">
        <i className="ri-loader-4-line animate-spin text-2xl text-primary-600"></i>
      </span>
      <p className="text-sm text-foreground-600">{label}</p>
    </div>
  );

  if (!fullScreen) return content;

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-background-50">
      {content}
    </div>
  );
}